import 'angular:locale/data:fr';
import 'angular:locale/data:de';
import 'angular:locale/data:en';
import 'angular:locale/data:nl';
import './apps/dash/randy/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
